import { cn } from '@/lib/utils';
import { STATUS_TONE_CLASS, type StatusTone } from '@/lib/status';
import type { ComponentProps } from 'react';

/**
 * The status pill from the prototype: `rounded-md px-2 py-0.5 text-[11.5px] font-bold`
 * with one of four tints.
 *
 * It takes a tone and a label rather than a status string, because the tone comes from
 * the domain enum (`@/lib/status`) and the label comes from the message catalog. Callers
 * that have a `VerificationStatus` in hand pair it with `verificationTone()`.
 */
export interface StatusBadgeProps extends ComponentProps<'span'> {
  tone: StatusTone;
}

export function StatusBadge({ tone, className, children, ...props }: StatusBadgeProps) {
  return (
    <span
      data-slot="status-badge"
      data-tone={tone}
      className={cn(
        'inline-block rounded-md px-2 py-0.5 text-[11.5px] font-bold whitespace-nowrap',
        STATUS_TONE_CLASS[tone],
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
}
